import Modal from '@components/Modal.vue';
import { URL_USER_DELETE_MODAL } from '@tools/routes/routes';
import { Attach } from '@tools/attach';
import { showSubmitLoader } from '@atoms/spinner';
import { translationMixin } from '@elements/translation';
import { requestsMixin } from '@tools/requests-mixin';
import { eventBus } from '@tools/event-bus';

export const DeleteModalComponent = {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: {
    isOpened: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [ translationMixin, requestsMixin ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
    };
  },
  methods: {
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }
      this.modalTitle = this.trans('user.modal.delete.title');
      this.get(URL_USER_DELETE_MODAL).then((templateResponse) => {
        this.htmlBody = templateResponse.data;

        Attach.onClickEvent('classic-cancel-button', () => {
          this.close();
        });

        this.$nextTick(() => {
          const deleteButton = document.getElementById('delete-button');
          if (deleteButton) {
            deleteButton.addEventListener('click', (event) => {
              event.preventDefault();
              showSubmitLoader(event.currentTarget);

              this.get(event.currentTarget.href).then(() => {
                eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
                  detail: {
                    oldModalName: 'Delete',
                    newModalName: 'DeleteSuccess',
                  },
                }));
              });
            });
          }
        });
      });
    },
  },
};
